import '@babel/polyfill';
// react
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { StoreContext } from 'redux-react-hook';
import zhCN from 'antd/es/locale/zh_CN';
import {ConfigProvider} from 'antd';
// components
import App from './App';
import BookingList from './pages/BookingList';
import Booking from './pages/Booking';
import Redirect from './pages/Redirect';
import FeedbackReport from './pages/FeedbackReport';
import SubscribeRecord from './pages/SubscribeRecord';
// apis & store & utils
import * as serviceWorker from './serviceWorker';
import store from './store';
// assets
import './assets/css/base.less';
/** 启动ARMS */
import { setAliArms } from './utils/browerLogger';
setAliArms();
ReactDOM.render((
    <ConfigProvider locale={zhCN}>
        <StoreContext.Provider value={store}>
            <Router>
                <Route
                    component={App}
                    path="/tutor" />
                <Route
                    component={BookingList}
                    path="/tutor/bookinglist" />
                <Route
                    component={Booking}
                    path="/tutor/booking/:id" />
                <Route
                    component={Redirect}
                    path="/tutor/redirect" />
                <Route    
                    component={FeedbackReport}
                    path="/tutor/feedback" />
                <Route    
                    component={SubscribeRecord}
                    path="/tutor/subscribe/:id" />
            </Router>
        </StoreContext.Provider>
    </ConfigProvider>
), document.getElementById('root'));
// http://dev-booking.gaodun.com:3000
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();